import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Store the entire API response here
  ip: [],
  senderaccount: [],
  payoutlist: [],
  fundlist: [],
  iplist: [],
  senderaccountlist : [],
  payoutbenelist: []
};

const InitiatepayoutSlice = createSlice({
  name: "Initiatepayout",
  initialState,
  reducers: {
    Initiatepayoutmerchants: (state, action) => {
      state.data = action.payload; // Store the entire API response
    },
    Initiatepayoutmerchants_ip: (state, action) => {
        state.ip = action.payload; // Store the entire API response
    },
    Initiatepayoutmerchants_sender_account: (state, action) => {
        state.senderaccount = action.payload; // Store the entire API response
    },
    payouthistry: (state, action) => {
      state.payoutlist = action.payload; // Store the entire API response
    },
    fundhistry: (state, action) => {
      state.fundlist = action.payload; // Store the entire API response
    },
    iphistry: (state, action) => {
      state.iplist = action.payload; // Store the entire API response
    },
    senderaccounthistry: (state, action) => {
      state.senderaccountlist = action.payload; // Store the entire API response
    },
    payoutbenehistry: (state, action) => {
      state.payoutbenelist = action.payload; // Store the entire API response
    }
    
  },
});

export const { Initiatepayoutmerchants , Initiatepayoutmerchants_ip , Initiatepayoutmerchants_sender_account  , payouthistry ,fundhistry,iphistry,senderaccounthistry,payoutbenehistry} = InitiatepayoutSlice.actions;
export default InitiatepayoutSlice.reducer;